// Mappning fran LocoPOS FoodAllergen-enum till visningsbar text.
// EU:s 14 standardallergener — matchar exakt samma enum som backoffice
// anvander nar den sparar via updateMenuProduct.

type Locale = 'sv' | 'en'

const ALLERGEN_LABELS: Record<string, Record<Locale, string>> = {
  CerealsContainingGluten: { sv: 'Gluten', en: 'Gluten' },
  Crustaceans: { sv: 'Kräftdjur', en: 'Crustaceans' },
  Eggs: { sv: 'Ägg', en: 'Eggs' },
  Fish: { sv: 'Fisk', en: 'Fish' },
  Peanuts: { sv: 'Jordnötter', en: 'Peanuts' },
  Soybeans: { sv: 'Soja', en: 'Soybeans' },
  Milk: { sv: 'Mjölk', en: 'Milk' },
  Nuts: { sv: 'Nötter', en: 'Tree nuts' },
  Celery: { sv: 'Selleri', en: 'Celery' },
  Mustard: { sv: 'Senap', en: 'Mustard' },
  SesameSeeds: { sv: 'Sesam', en: 'Sesame seeds' },
  SulphurDioxideAndSulphites: { sv: 'Svaveldioxid', en: 'Sulphur dioxide' },
  Lupin: { sv: 'Lupin', en: 'Lupin' },
  Molluscs: { sv: 'Blötdjur', en: 'Molluscs' },
}

/** Returnerar lokaliserade allergen-namn sorterade alfabetiskt. */
export function formatAllergens(allergens: string[] | null | undefined, locale: string): string[] {
  if (!allergens || allergens.length === 0) return []
  const loc: Locale = locale === 'en' ? 'en' : 'sv'
  return allergens.map((a) => ALLERGEN_LABELS[a]?.[loc] || a).sort((a, b) => a.localeCompare(b, loc === 'sv' ? 'sv' : 'en'))
}
